import React from 'react';
import { Alert } from '../alert';

export default function UnknownErrorAlert() {
  return <Alert text="" />;
}
